<template>
  <ul class="ml-auto" v-bind:class="{'navbar-nav': isDesktop}">
    <!-- TODO:  ml-auto ustawia nawigację z prawej strony. usunąć po wyświetleniu koszyka -->
    <li v-for="menuItem in menu" :key="menuItem.url"
        class="menu-item" :class="{'menu-item-has-children': menuItem.isParent}">
      <router-link :to="menuItem.url" v-on:click.native="hideMobileMenu">
        {{ menuItem.title }}
      </router-link>
      <ul v-if="menuItem.isParent" class="submenu">
        <li v-for="subMenuItem in menuItem.getChildren" :key="subMenuItem.url" class="menu-item">
          <router-link :to="subMenuItem.url">
            {{ subMenuItem.title }}
          </router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
import {mapMutations} from "vuex";

export default {
  name: 'top-menu',
  props: {
    menu: Array,
    isDesktop: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    ...mapMutations({
      hideMobileMenu: "hideMobileMenu"
    })
  }
}
</script>